var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field)?_c('b-form-input',{ref:'field-' + _vm.field.name,staticClass:"dynamic-input-text",attrs:{"plaintext":_vm.viewMode,"name":_vm.field.name,"type":_vm.type,"id":_vm.field.name,"required":_vm.field.required,"placeholder":"..."},on:{"input":function($event){return _vm.fixValue(_vm.field, _vm.inputValue)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9317782","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForms/InputText.vue
// module id = 793
// module chunks = 43